import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'lib-basic-modal',
    templateUrl: './basic-modal.component.html',
    styleUrls: ['./basic-modal.component.css'],
    standalone: false
})
export class BasicModalComponent {
  title: string;
  htmlContent: string;
  hideFooter: boolean;
  @Input()
  btnText = 'OK';
  
  @Input()
  hideClose = false;

  constructor(public activeModal: NgbActiveModal) { }
}
